import { render, staticRenderFns } from "./CurationWriteItemsLayout.vue?vue&type=template&id=b7d42794&scoped=true"
import script from "./CurationWriteItemsLayout.vue?vue&type=script&lang=js"
export * from "./CurationWriteItemsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d42794",
  null
  
)

export default component.exports